var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"disable-scroll-x"},_vm._l((_vm.metaInfo.link),function(link,index){return (_vm.metaInfo.link)?_c('meta',{key:index,attrs:{"href":link.href,"rel":link.rel}}):_vm._e()}),0)}
var staticRenderFns = []

export { render, staticRenderFns }